import { Button } from '@factorialco/deprecated-design-system'
import {
  DeleteProcurementTypeDocument,
  NewRequestPageDocument,
  ProcurementSettingsPageDocument,
  ProcurementTypeItemFragment,
  ProcurementTypesDataCollectionDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  requestType: ProcurementTypeItemFragment | null
  onClose: () => void
}

const DeleteRequestTypeModal = ({ requestType, onClose }: Props) => {
  const { company } = useCurrentSession()

  const [deleteProcurementType] = useMutation(DeleteProcurementTypeDocument, {
    extractorFn: (data) => data.procurementMutations.deleteProcurementType,
  })
  if (!requestType) return null

  const onDeleteType = async () => {
    const result = await deleteProcurementType({
      variables: {
        id: requestType.id,
        companyId: company.id,
      },
      refetchQueries: [
        ProcurementSettingsPageDocument,
        NewRequestPageDocument,
        ProcurementTypesDataCollectionDocument,
      ],
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('procurement.purchase_requests.settings.types.modals.delete.success'),
      })

      handleClose()
    }

    return handled
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('procurement.purchase_requests.settings.types.modals.delete.title')}
      description={i18n.t(
        'procurement.purchase_requests.settings.types.modals.delete.description',
        { name: requestType.name }
      )}
      footer={
        <>
          <Button type="secondary" onClick={handleClose}>
            {i18n.t('procurement.purchase_requests.settings.types.modals.delete.buttons.cancel')}
          </Button>
          <Button onClick={onDeleteType}>
            {i18n.t('procurement.purchase_requests.settings.types.modals.delete.buttons.delete')}
          </Button>
        </>
      }
      onClose={onClose}
    />
  )
}

export default DeleteRequestTypeModal
